import { render } from "./Accueil.vue?vue&type=template&id=5abec794&scoped=true"
import script from "./Accueil.vue?vue&type=script&lang=js"
export * from "./Accueil.vue?vue&type=script&lang=js"

import "./Accueil.vue?vue&type=style&index=0&id=5abec794&lang=scss&scoped=true"

import exportComponent from "/home/maud/code/ixperya2.0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5abec794"]])

export default __exports__